import * as zod from 'zod';

import { DeviceCommand } from '@sb/integrations/types';
import { Expression } from '@sb/routine-runner';

export const MoveVerticalLiftArguments = zod.union([
  zod.object({
    deviceCommand: DeviceCommand,
  }),
  zod.object({
    targetHeight: Expression,
    unitScaleToMeters: zod.number().optional(),
  }),
]);

export type MoveVerticalLiftArguments = zod.infer<
  typeof MoveVerticalLiftArguments
>;
